import { marketServiceInstance } from './market.service.instance';
import type { MarketAccountResponse } from './interfaces/account.types';
import { normalizeMarketAccountResponse } from './interfaces/account.types';

export const getMarketAccount = async (): Promise<MarketAccountResponse> => {
  const response = await marketServiceInstance.get<MarketAccountResponse>('/account');
  return normalizeMarketAccountResponse(response.data);
};
